const menuList = [
  {
    key: 'tokenV1',
    title: 'setting.list.development.oldTitle',
    desc: 'setting.list.development.oldDescription',
    pathName: 'Setting Token API V1',
  },
  {
    key: 'tokenV2',
    title: 'setting.list.development.newTitle',
    desc: 'setting.list.development.newDescription',
    pathName: 'Setting Token API V2',
  },
]

export default menuList
